var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page--padding terms"},[_c('section',{staticClass:"section--page"},[_c('v-container',[_c('span',{domProps:{"innerHTML":_vm._s(this.terms)}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }